import apiUseCases from "../api";

export interface UpdateSourceNameTypes {
  name: string;
  source_id: string;
  source_type: string;
}

export const updateSourceName = async (dto: UpdateSourceNameTypes) => {
  const response = await apiUseCases.putsUpdateSourceName(dto);
  return response;
};
